import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL: 'https://www.ncswhn.com/api', // API的基础URL
  timeout: 15000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么，如添加认证token
    // config.headers['X-Token'] = getToken() // 例如：从localStorage获取token
    return config
  },
  error => {
    // 请求错误处理
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // 根据后端约定的code字段判断请求是否成功
    if (res.code !== 200) {
      // 统一错误处理
      console.error(res.msg || 'Error')

      // 可以根据不同错误码做不同处理
      if (res.code === 401) {
        // 未授权，跳转到登录页
        // router.push('/login')
      }

      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      // 请求成功，返回数据
      return res
    }
  },
  error => {
    // HTTP状态码错误处理
    console.error('err' + error) // for debug

    // 根据错误状态码进行处理
    let message = '请求失败'
    if (error.response) {
      const status = error.response.status
      switch (status) {
        case 400:
          message = '请求参数错误'
          break
        case 401:
          message = '未授权，请重新登录'
          break
        case 403:
          message = '拒绝访问'
          break
        case 404:
          message = '请求地址不存在'
          break
        case 500:
          message = '服务器内部错误'
          break
        default:
          message = `连接错误 ${status}`
      }
    } else if (error.request) {
      // 请求已发出但没有收到响应
      message = '网络连接异常'
    } else {
      // 其他错误
      message = error.message
    }

    return Promise.reject(new Error(message))
  }
)

export default service